import { Tag, Tooltip } from 'antd';
import { DataTableColumnHeader } from 'common/data-table-column-header';
import { FilterFieldConfig } from 'common/dynamic-filter-form';
import { dateTimeCell, linkCell } from 'utils/cell-formatter';

const PROVIDER_COLORS: Record<string, string> = {
  apple: 'default',
  google: 'green',
};

const STATUS_COLORS: Record<string, string> = {
  received: 'blue',
  processed: 'green',
  failed: 'red',
  skipped_duplicate: 'default',
};

const ENVIRONMENT_COLORS: Record<string, string> = {
  Sandbox: 'orange',
  Production: 'green',
};

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/investment/iap-notifications' }),
  },
  {
    accessorKey: 'provider',
    header: 'Provider',
    cell: ({ getValue }) => {
      const value = getValue();
      return <Tag color={PROVIDER_COLORS[value]}>{value}</Tag>;
    },
  },
  {
    accessorKey: 'environment',
    header: 'Environment',
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return '-';
      return <Tag color={ENVIRONMENT_COLORS[value] ?? 'default'}>{value}</Tag>;
    },
  },
  {
    accessorKey: 'notification_type',
    header: 'Type',
  },
  {
    accessorKey: 'external_id',
    header: 'External ID',
  },
  {
    accessorKey: 'subscription_user',
    header: 'User',
    cell: ({ getValue }) => getValue()?.user?.email ?? '-',
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => {
      const value = row.original.status;
      const errorMessage = row.original.error_message;
      const tag = <Tag color={STATUS_COLORS[value]}>{value}</Tag>;
      if (value === 'failed' && errorMessage) {
        return <Tooltip title={errorMessage}>{tag}</Tooltip>;
      }
      return tag;
    },
  },
  {
    accessorKey: 'created_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Received At" />
    ),
    cell: dateTimeCell,
  },
];

export const filterConfig: FilterFieldConfig[] = [
  {
    name: 'provider',
    type: 'select',
    label: 'Provider',
    placeholder: 'All',
    minWidth: '100px',
    options: [
      { value: 'apple', label: 'Apple' },
      { value: 'google', label: 'Google' },
    ],
    defaultValue: 'all',
  },
  {
    name: 'environment',
    type: 'select',
    label: 'Environment',
    placeholder: 'All',
    minWidth: '120px',
    options: [
      { value: 'Sandbox', label: 'Sandbox' },
      { value: 'Production', label: 'Production' },
    ],
    defaultValue: 'all',
  },
  {
    name: 'status',
    type: 'select',
    label: 'Status',
    placeholder: 'All',
    minWidth: '140px',
    options: [
      { value: 'received', label: 'Received' },
      { value: 'processed', label: 'Processed' },
      { value: 'failed', label: 'Failed' },
      { value: 'skipped_duplicate', label: 'Skipped (duplicate)' },
    ],
    defaultValue: 'all',
  },
];
